<template>
  <section :class="isMobile ? 'repair-step mobile-repair-step' : 'repair-step'">
    <div class="title">售后返修信息</div>

    <div class="form">
      <div>
        <div class="df">
          <div class="label">对接人：</div>
          <div class="data">{{ afterSaleQuestionInfo.contactPerson }}</div>
        </div>
        <div class="df">
          <div class="label">设备型号：</div>
          <div class="data">{{ afterSaleQuestionInfo.serial }}</div>
        </div>
        <div>
          <div
            class="df"
            v-for="(item, index) in afterSaleQuestionInfo.describe"
            :key="index"
          >
            <div class="label">售后问题{{ index + 1 }}：</div>
            <div class="data">
              {{ item.value }}
            </div>
          </div>
        </div>

        <div>
          <div class="df">
            <div class="label">售后问题图片：</div>
            <div
              class="data"
              v-for="(item, index) in afterSaleQuestionInfo.picture"
              :key="index"
            >
              <a-image :width="100" :src="item" />
            </div>
          </div>
        </div>

        <div>
          <div class="df">
            <div class="label">售后问题视频：</div>
            <div
              class="data"
              v-for="(item, index) in afterSaleQuestionInfo.video"
              :key="index"
            >
              <video :src="item" controls width="250" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { defineComponent, reactive, watch, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    machine: Object,
  },
  setup(props, context) {
    const store = useStore();
    const isMobile = computed(() => store.state.isMonile);

    const afterSaleQuestionInfo = reactive({
      describe: null,
      picture: null,
      video: null,
      serial: null,
      contactPerson: null,
    });

    watch(
      () => props.machine,
      (val) => {
        afterSaleQuestionInfo.describe = JSON.parse(
          val.afterSaleProblemDescription
        );
        afterSaleQuestionInfo.picture = JSON.parse(val.picture);
        afterSaleQuestionInfo.video = JSON.parse(val.video);

        afterSaleQuestionInfo.serial = val.serial;
        afterSaleQuestionInfo.contactPerson = val.contactPerson;
      },
      {
        immediate: true,
        deep: true,
      }
    );
    return {
      store,
      isMobile,
      afterSaleQuestionInfo,
    };
  },
});
</script>

<style lang="less" scoped>
.label {
  font-size: 16px;
  width: 120px;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: right;
}
.data {
  margin-left: 30px;
  font-size: 16px;
}
</style>
